import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Breadcrumbs, Card, CardContent, Chip, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  getPictreePhotoShootByAssetCommon,
  getPictreePhotoShootTrendByAssetCommon,
  setCurrentPage,
  setPictreeChartSize,
} from "actions";
import * as C from "components";
import * as V from "styles/variables";
import CalendarRangePicTreeCommon from "components/Calendar/CalendarRangePicTreeCommon";
import PhotoShootAssetTypeCommon from "components/PicTree/Home/PhotoShootAssetTypeCommon";
import PicTreeTablePhotoSubTypeCommon from "components/Table/PicTreeTablePhotoSubTypeCommon";
import LineChartPictreePhotoShoot from "components/Charts/LineChartPictreePhotoShoot";
import SingleSelect from "components/Select/SingleSelect";

const useStyles = makeStyles((theme) => ({
  breadcrumbs: { marginTop: 16, minHeight: 30 },
  gridSection: { marginTop: theme.spacing(1) },
  loaderBox: { width: "100%", minHeight: 280, display: "flex", alignItems: "center", justifyContent: "center" },
  loaderBarImg: { width: 40 },
  noData: { minHeight: 280, display: "flex", alignItems: "center", justifyContent: "center" },
}));

const PicTreeReviewByAssetTypeCommon = ({
  pageTopLoader,
  dateRangePicTreeCommon,
  photoShootTrendByAsset,
  setCurrentPage,
  getPictreePhotoShootByAssetCommon,
  getPictreePhotoShootTrendByAssetCommon,
  setPictreeChartSize,
}) => {
  const classes = useStyles();
  const [chartSize, setChartSize] = useState({ name: "日別", value: "day" });
  const [initialDataCall, setInitialDataCall] = useState(true);

  useEffect(() => { setCurrentPage(window.location.pathname); }, [setCurrentPage]);
  useEffect(() => {
    if (dateRangePicTreeCommon[0] !== null && dateRangePicTreeCommon[1] !== null && initialDataCall) {
      getPictreePhotoShootByAssetCommon();
      getPictreePhotoShootTrendByAssetCommon("day");
      setInitialDataCall(false);
    }
  }, [dateRangePicTreeCommon, initialDataCall, getPictreePhotoShootByAssetCommon, getPictreePhotoShootTrendByAssetCommon]);

  const handleChange = (event) => {
    const value = event.target.value;
    setChartSize(value);
    setPictreeChartSize(value);
    getPictreePhotoShootTrendByAssetCommon(value);
  };
  const legend = photoShootTrendByAsset?.[0]
    ? Object.keys(photoShootTrendByAsset[0]).filter((key) => key !== "date")
    : [];
  const seriesConfig = legend.reduce((config, key) => ({ ...config, [key]: key }), {});

  return (
    <Fragment>
      <C.ContentWrapper>
        <Grid container spacing={0} direction="row" style={{ marginTop: -16, marginBottom: 8 }} justifyContent="space-between">
          <Grid item><Breadcrumbs separator="›" className={classes.breadcrumbs}><Typography>PicTrée 汎用事業者</Typography><Typography>撮影</Typography><Typography>アセットタイプ別</Typography></Breadcrumbs></Grid>
          <Grid item><CalendarRangePicTreeCommon mDate="2026/09/01" page="pictree" pictree /></Grid>
        </Grid>
        <Grid container spacing={0}><Grid item xs={12}><Card><CardContent><PhotoShootAssetTypeCommon /></CardContent></Card></Grid></Grid>
        <Grid container spacing={0} style={{ marginTop: 16, marginBottom: 8 }} justifyContent="space-between">
          <Grid item><SingleSelect selected={chartSize} options={[{ name: "時間別", value: "hour" }, { name: "日別", value: "day" }]} handleChange={handleChange} /></Grid>
        </Grid>
        <Grid container spacing={1} className={classes.gridSection}><Grid item xs={12}>
          {pageTopLoader ? <div className={classes.loaderBox}><img alt="" className={classes.loaderBarImg} src="/static/images/loader-bar.gif" /></div> : photoShootTrendByAsset.length > 0 ? (
            <LineChartPictreePhotoShoot legend={legend} xAisData={photoShootTrendByAsset[0].date} seriesData={photoShootTrendByAsset} chartType="bar" chartConfig={seriesConfig} colorValue={V.genericColorPallette} yAxis={[{ type: "value", name: "レビューOK基数", axisLine: { show: true } }]} />
          ) : <div className={classes.noData}><Chip label="No Data" style={{ color: V.textColor, backgroundColor: V.placeholderColor }} /></div>}
        </Grid></Grid>
        <Grid container spacing={1} className={classes.gridSection}><Grid item xs={12}><PicTreeTablePhotoSubTypeCommon photoShootTrend={photoShootTrendByAsset} /></Grid></Grid>
      </C.ContentWrapper>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  pageTopLoader: state.page.pageTopLoader,
  dateRangePicTreeCommon: state.page.dateRangePicTreeCommon,
  photoShootTrendByAsset: state.pictreeCommon.photoShootTrendByAsset,
});
const mapDispatchToProps = (dispatch) => ({
  setCurrentPage: (param) => dispatch(setCurrentPage(param)),
  getPictreePhotoShootByAssetCommon: (param) => dispatch(getPictreePhotoShootByAssetCommon(param)),
  getPictreePhotoShootTrendByAssetCommon: (param) => dispatch(getPictreePhotoShootTrendByAssetCommon(param)),
  setPictreeChartSize: (param) => dispatch(setPictreeChartSize(param)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PicTreeReviewByAssetTypeCommon);
